import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CameraServerService } from '../../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppConstants } from 'src/app/shared/app-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-site-cam-live-views',
  templateUrl: './site-cam-live-views.component.html',
  styleUrls: ['./site-cam-live-views.component.scss']
,
  standalone: false
})

export class SiteCamLiveViewsComponent implements OnInit, OnDestroy {

  cameraListData: any = [];
  potentialId: string = '';
  liveViewImageUrl: any;
  counter: any = 0;
  // liveView_ImageUrl = `${environment.camServerLiveViewAPI}snap/manager/fetch/latest/image`;
  liveView_ImageUrl = '';
  getCurrentTime: any = '';
  liveViewsLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
  ) { }

  ngOnInit(): void {
    console.log("this.data", this.data)
    this.liveView_ImageUrl = `${this.data?.siteAccess !== '' ? this.data?.siteAccess : environment.camServerLiveViewAPI}snap/manager/fetch/latest/image`;
    this.liveViewsLoading = true;
    if (this.data.isSingleCam) {
      this.cameraListData = this.data.isSingleCam;
      this.liveViewsLoading = false;
    } else {
      this.getCameraByPotentialId();
    }
    clearInterval(this.counter);
  }

  getCameraByPotentialId() {
    this.potentialId = this.data.vtigerPotentialId;
    if (this.potentialId) {
      this.spinner.activate();
      this.camService.getCamByPotentialId(this.potentialId).subscribe((response: any) => {
        this.liveViewsLoading = false;
        if (response && response.success) {
          this.spinner.deactivate();
          this.cameraListData = response?.data?.cams !== null ? response?.data?.cams : [];
        } else {
          this.spinner.deactivate();
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.spinner.deactivate();
        this.liveViewsLoading = false;
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  ngAfterViewInit() {
    this.counter = setInterval(() => {
      if (this.cameraListData && this.cameraListData.length !== 0) {
        this.potentialId = this.data.vtigerPotentialId;
      }
      this.counter++;
      this.getCurrentTime = new Date().toLocaleString();
    }, 1000)
    // clearInterval(this.counter);
  }

  ngOnDestroy() {
    clearInterval(this.counter);
  }

  // getSiteCamImgLiveView() {
  //   this.cameraListData.map((item: any) => {
  //     // console.log("item", item.camUniqueId)
  //     ids = item.camUniqueId;
  //     return liveView_ImageUrl = `${environment.camServerLiveViewAPI}snap/manager/fetch/latest/image?potentialId=${this.data.vtigerPotentialId}&camUniqueId=${item.camUniqueId}`
  //   })
  // }

}
